export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const REGIS_URL = process.env.REACT_APP_REGIS_URL;
